module.exports = __webpack_public_path__ + "79f4c38998271f77c0565f0a1c7835de.svg";